import sdl from '@jds/react-generated-sdl/JDSServiceCard';
import type { JDSServiceCardProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ServiceCardProps } from '../logic';

const Component = (props: ServiceCardProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'xtra-xtra-small',
    imageRatio = 'wide',
    shadow = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, imageRatio, shadow, ...rest },
    'JDSServiceCard',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ServiceCard = withLogic(Component) as React.FC<ServiceCardProps> & {
  slotName?: string;
};

ServiceCard.displayName = 'ServiceCard';
ServiceCard.slotName = 'jds_service_card';

export { ServiceCard, type JDSServiceCardProps };
